import { render, staticRenderFns } from "./IndicatorPlugin.vue?vue&type=template&id=584f9506&scoped=true"
import script from "./IndicatorPlugin.vue?vue&type=script&lang=ts"
export * from "./IndicatorPlugin.vue?vue&type=script&lang=ts"
import style0 from "./IndicatorPlugin.vue?vue&type=style&index=0&id=584f9506&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f9506",
  null
  
)

export default component.exports